import React, { useEffect, useState } from "react";
import axios from "axios";
import "./admindashboard.css";

const API =
  process.env.REACT_APP_BACKEND_URL ||
  "http://localhost:10000";

export default function AdminDashboard() {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    loadLeads();
  }, []);

  const loadLeads = async () => {
    try {
      const res = await axios.get(
        `${API}/api/leads`
      );

      setLeads(res.data.leads || []);
    } catch (err) {
      console.log(err);
    }
  };

  const logout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user");

    window.location.href = "/login";
}

  return (
    <div className="dashboard">

      <div className="dashboard-header">

        <div>
          <div className="dashboard-badge">
            LEAD MANAGEMENT
          </div>

          <h1 className="dashboard-title">
            Lead
            <span className="highlight">
              Hub
            </span>
          </h1>
        </div>

        <button
          className="logout-btn"
          onClick={logout}
        >
          Logout
        </button>

      </div>

      <div className="stats-grid">

        <div className="stat-card lime">
          <p>Total Leads</p>
          <h2>{leads.length}</h2>
        </div>

        <div className="stat-card pink">
          <p>New Leads</p>
          <h2>{leads.length}</h2>
        </div>

        <div className="stat-card blue">
          <p>Today's Leads</p>
          <h2>{leads.length}</h2>
        </div>

      </div>

      <div className="table-card">

        <div className="table-title">
          All Leads
        </div>
        {/* <div className="table-wrapper"> */}
        <table className="leads-table">

          <thead>
            <tr>
              <th>Name</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Service</th>
              <th>Message</th>
            </tr>
          </thead>

          <tbody>

            {leads.map((lead, index) => (

              <tr key={index}>

                <td>{lead.full_name}</td>

                <td>{lead.mobile}</td>

                <td className="email-cell">{lead.email}</td>

                <td>{lead.service}</td>

                <td>{lead.message}</td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
}